/* import __COLOCATED_TEMPLATE__ from './inserter-options.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable @intercom/intercom/no-bare-strings */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { HORIZONTAL_RULE_FALLBACK } from '@intercom/composer-ember/lib/blocks/constants';
import { SECTION_TYPE } from '@intercom/interblocks.ts';
import { findParentNodeClosestToPos } from 'prosemirror-utils';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import intermoji from '@intercom/intermoji';
let InserterOptions = (_class = class InserterOptions extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isInsertingEmoji", _descriptor, this);
    _initializerDefineProperty(this, "isInsertingTour", _descriptor2, this);
    _initializerDefineProperty(this, "isInsertingNews", _descriptor3, this);
    _initializerDefineProperty(this, "isInsertingApp", _descriptor4, this);
    _initializerDefineProperty(this, "isInsertingVideo", _descriptor5, this);
    _initializerDefineProperty(this, "isInsertingLayout", _descriptor6, this);
    _initializerDefineProperty(this, "isInsertingSocialButton", _descriptor7, this);
    _initializerDefineProperty(this, "isInsertingImageText", _descriptor8, this);
    _defineProperty(this, "trackAnalyticsEvent", (blockType, event = 'inserted') => {
      this.args.composer.config.analytics?.trackAnalyticsEvent(event, {
        block_type: blockType
      });
    });
  }
  get schema() {
    return this.args.composer.state.prosemirrorState.schema;
  }
  get state() {
    return this.args.composer.state;
  }
  get showInsertTableOption() {
    return this.schema.nodes.table && !this.args.composer.state.selectionIsInTable && !this.args.composer.state.selectionIsInNestedList && !this.args.composer.config.tables.responsive;
  }
  get showInsertResponsiveTableOption() {
    return this.schema.nodes.table && !this.insertionPointIsInLayout && this.args.composer.config.tables.responsive;
  }
  get insertionPointIsInLayout() {
    let insertionPointNode = this.findInsertionPointTableNode;
    return isPresent(insertionPointNode) && insertionPointNode?.node.attrs.responsive;
  }
  get insertionPointIsInContainer() {
    let insertionPointNode = this.findInsertionPointTableNode;
    return isPresent(insertionPointNode) && insertionPointNode?.node.attrs.container;
  }
  get canShowInsertSocialButtons() {
    return this.args.composer.config.allowedBlocks.includes('twitterFollowButton') && this.schema.nodes.twitterFollowButton && this.args.composer.config.allowedBlocks.includes('facebookLikeButton') && this.schema.nodes.facebookLikeButton;
  }
  insertAnchorMarker() {
    this.args.composer.commands.insertText(' ');
    let marker = this.args.composer.commands.insertMarker({
      class: 'embercom-prosmirror-composer-anchor-placeholder'
    });
    this.args.composer.anchorInsertionMarker = marker;
  }
  addAttachment(file) {
    this.args.onClose();
    this.args.composer.commands.addAttachment(file);
  }
  insertCodeBlock() {
    this.args.insertBlock({
      type: 'code',
      text: ''
    });
  }
  insertParagraphBlock() {
    this.args.insertBlock({
      type: 'paragraph',
      text: ''
    });
  }
  insertButtonBlock() {
    this.trackAnalyticsEvent('button');
    if (this.args.composer.config.customStylesConfig?.disableButtonAutoFontColor) {
      // Preventing button text from being changed on background change,
      // not needed in template editor as users can change font color themselves
      this.args.insertBlock({
        type: 'button',
        text: '',
        buttonStyle: 'solid',
        style: {
          fontColor: '#FFFFFF'
        }
      });
    } else {
      this.args.insertBlock({
        type: 'button',
        text: '',
        buttonStyle: 'solid'
      });
    }
  }
  insertContainerBlock() {
    this.args.insertBlock({
      type: 'table',
      container: true,
      sectionType: SECTION_TYPE.content,
      rows: [{
        cells: [{
          content: []
        }]
      }]
    });
  }
  insertEmoji(emojiIdentifier) {
    this.isInsertingEmoji = false;
    let unicode = intermoji.unicodeFromIdentifier(emojiIdentifier);
    this.args.composer.commands.insertText(unicode);
    this.args.composer.commands.focus();
  }
  insertTour(tourCardData) {
    this.isInsertingTour = false;
    this.insertMessengerCard(tourCardData);
  }
  insertNews(newsCardData) {
    this.isInsertingNews = false;
    this.insertMessengerCard(newsCardData);
  }
  insertApp(appCardData) {
    this.isInsertingApp = false;
    this.insertMessengerCard(appCardData);
  }
  insertMessengerCard(cardData) {
    this.args.insertBlock({
      type: 'messengerCard',
      ...cardData
    });
    this.args.composer.commands.focus();
  }
  insertOrderedList() {
    this.trackAnalyticsEvent('ordered_list');
    this.args.insertBlock({
      type: 'orderedList',
      items: []
    });
  }
  insertTableBlock() {
    this.args.insertBlock({
      type: 'table',
      rows: [{
        cells: [{
          content: []
        }, {
          content: []
        }, {
          content: []
        }]
      }, {
        cells: [{
          content: []
        }, {
          content: []
        }, {
          content: []
        }]
      }, {
        cells: [{
          content: []
        }, {
          content: []
        }, {
          content: []
        }]
      }]
    });
  }
  insertSocialBlock() {
    this.args.insertBlock({
      type: 'social',
      align: 'center',
      items: [{
        provider: 'x',
        url: ''
      }, {
        provider: 'facebook',
        url: ''
      }, {
        provider: 'instagram',
        url: ''
      }]
    });
  }
  insertSpacerBlock() {
    this.trackAnalyticsEvent('spacer');
    this.args.insertBlock({
      type: 'spacer',
      height: 20
    });
  }
  insertTicketCard() {
    this.args.composer.commands.insertCreateTicketCard({
      icon_url: 'https://some-url-for-ticket-icon.com',
      state: 'interactive',
      text: 'Admin has requested you to create a ticket',
      ticket_type_id: 1,
      ticket_type_title: 'API Issue',
      title: 'Create ticket',
      type: 'createTicketCard'
    });
    this.args.composer.outputNewBlocksDoc();
  }
  insertUnorderedList() {
    this.trackAnalyticsEvent('unordered_list');
    this.args.insertBlock({
      type: 'unorderedList',
      items: []
    });
  }
  insertHorizontalRule() {
    this.args.insertBlock({
      type: 'horizontalRule',
      text: HORIZONTAL_RULE_FALLBACK
    });
  }
  insertImage(file) {
    this.trackAnalyticsEvent('image');
    this.args.onClose?.();
    if (this.args.insertionPoint) {
      let pos = this.args.insertionPoint.pos;
      this.args.composer.commands.insertImageFileAtRange({
        from: pos,
        to: pos
      }, file);
      this.args.composer.commands.focus();
    }
  }
  insertImageText(imageTextData) {
    this.isInsertingImageText = false;
    this.args.onClose?.();
    this.args.insertBlock(imageTextData);
    this.args.composer.commands.focus();
  }
  insertVideoClip(file) {
    this.args.onClose?.();
    if (this.args.insertionPoint) {
      let pos = this.args.insertionPoint.pos;
      this.args.composer.commands.insertVideoFileAtRange({
        from: pos,
        to: pos
      }, file);
      this.args.composer.commands.focus();
    }
  }
  insertAudioFile(file) {
    this.args.onClose?.();
    if (this.args.insertionPoint) {
      let pos = this.args.insertionPoint.pos;
      this.args.composer.commands.insertAudioFileAtRange({
        from: pos,
        to: pos
      }, file);
      this.args.composer.commands.focus();
    }
  }
  doLayoutAnalytics() {
    this.args.composer.config.analytics?.trackAnalyticsEvent('opened', {
      block_type: 'table',
      item_name: 'insert_layout'
    });
  }
  onCancelImageTextInsertion() {
    this.isInsertingImageText = false;
    this.args.onClose?.();
    this.args.composer.commands.focus();
  }
  get findInsertionPointTableNode() {
    if (!this.args.insertionPoint) {
      return null;
    }
    return findParentNodeClosestToPos(this.state.prosemirrorState.doc.resolve(this.args.insertionPoint.pos), node => node.type === this.schema.nodes.table);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isInsertingEmoji", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isInsertingTour", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isInsertingNews", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isInsertingApp", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isInsertingVideo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isInsertingLayout", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isInsertingSocialButton", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isInsertingImageText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "insertAnchorMarker", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertAnchorMarker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addAttachment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addAttachment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertCodeBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertCodeBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertParagraphBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertParagraphBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertButtonBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertButtonBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertContainerBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertContainerBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertEmoji", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertEmoji"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertTour", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertTour"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertNews", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertNews"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertMessengerCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertMessengerCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertOrderedList", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertOrderedList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertTableBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertTableBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertSocialBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertSocialBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertSpacerBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertSpacerBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertTicketCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertTicketCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertUnorderedList", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertUnorderedList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertHorizontalRule", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertHorizontalRule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertImage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertImageText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertImageText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertVideoClip", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertAudioFile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertAudioFile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doLayoutAnalytics", [action], Object.getOwnPropertyDescriptor(_class.prototype, "doLayoutAnalytics"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCancelImageTextInsertion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCancelImageTextInsertion"), _class.prototype), _class);
export { InserterOptions as default };